import React, { useState } from "react";
import { Field } from "formik";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";

import "./input.scss";

const Input = (props) => {
    const [isShown, setShow] = useState(false);
    const setPassword = (isShown) => () => {
        setShow(isShown);
    };
    return (
        <div className={`${props.error && props.touched ? "input-block input-error" : "input-block"}`}>
            {props.type !== "hidden" && props.icon && <div className="input-icon">{props.icon}</div>}
            {props.type === "password" && (
                <div
                    className={`${isShown ? "input-password-icon shown" : "input-password-icon"}`}
                    onClick={setPassword(!isShown)}
                >
                    {isShown ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </div>
            )}
            {props.label && <label htmlFor={props.name}>{props.label}</label>}
            <Field
                type={props.type === "password" && isShown ? "text" : props.type}
                name={props.name}
                value={props.value}
                placeholder={props.placeholder}
                disabled={props.disabled}
            />
            {props.error && props.touched && <p className="error-text">{props.error}</p>}
        </div>
    );
};

export default Input;
